<template>
    <a :href="Domain+'/Recipes/'+RecipeID" @click.prevent="ShowRecipe">{{ Recipe.name }}</a>
</template>
<script>

export default {
    data() {
        return {
            Domain: this.$store.getters.SiteDomain()
        };
    },
    props: {
        RecipeID: {
            type: Number,
            default: 0
        }
    },
    computed: {
        Recipe() {
            let Recipe = this.$store.getters.Recipes_GetByID(this.RecipeID) || '';
            if (Recipe === '') { this.$store.dispatch('Recipes_GetByID', this.RecipeID); }
            return Recipe;
        }
    },
    mounted() {
    },
    methods: {
        ShowRecipe() {
            this.$store.dispatch('Recipes_FindModal', this.RecipeID);
        }
    }
};
</script>
